import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { MagnifyingGlass, MapPin } from "@phosphor-icons/react";
import { lies } from "../api/client";
import { Meldung } from "./Bausteine";

export interface Ort {
  anzeige: string;
  lang: string;
  ort: string;
  lat: number;
  lon: number;
  ungefaehr: boolean;
}

/** Adresssuche für den Baustellenort (SPEC §15.1): OpenStreetMap über unser Backend
 *  (geo.py). Gesucht wird nach einer kurzen Tipppause, nicht bei jedem Buchstaben —
 *  der Dienst erlaubt eine Anfrage je Sekunde. */
export function Ortssuche({ gewaehlt }: { gewaehlt: (o: Ort) => void }) {
  const [q, setQ] = useState("");
  const [wort, setWort] = useState("");
  const [offen, setOffen] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setWort(q.trim()), 600);
    return () => clearTimeout(t);
  }, [q]);
  const treffer = useQuery({
    queryKey: ["ortssuche", wort],
    queryFn: () => lies<Ort[]>(`/geo/suche?q=${encodeURIComponent(wort)}`),
    enabled: wort.length >= 3,
    staleTime: Infinity,
  });
  return (
    <div className="ortssuche">
      <label className="suche" style={{ width: "100%" }}>
        <MagnifyingGlass size={16} />
        <input className="eingabe" placeholder="Adresse der Baustelle suchen, z. B. Dorfplatz, Viermünden"
               value={q} onChange={(e) => { setQ(e.target.value); setOffen(true); }} />
      </label>
      {offen && wort.length >= 3 && (
        <div className="ort-treffer">
          {treffer.isFetching && <div className="mute">sucht …</div>}
          {treffer.data?.map((o, i) => (
            <button key={i} type="button" className="ort-zeile" title={o.lang}
                    onClick={() => { gewaehlt(o); setOffen(false); setQ(o.anzeige); }}>
              <MapPin size={15} />
              <span><b>{o.anzeige}</b><span className="mute"> · {o.lang}</span></span>
              {o.ungefaehr && <span className="chip warn">ungefähr</span>}
            </button>
          ))}
          {treffer.isSuccess && !treffer.isFetching && treffer.data.length === 0 &&
            <div className="mute">Nichts gefunden. Ort und Straße einzeln versuchen.</div>}
          <Meldung fehler={treffer.error} />
          <div className="mute klein">Adressdaten © OpenStreetMap-Mitwirkende</div>
        </div>
      )}
    </div>
  );
}
